import { forwardRef, useRef } from "react";
import styled from "styled-components";
import cx from "classnames";
import Motion from "rc-motion";
import Text from "../text";
import Box from "../box";
import { makeMotion } from "../../styles/mixins";
import { jsx as _jsx } from "react/jsx-runtime";
const StyledHelp = styled(Box).withConfig({
  displayName: "help__StyledHelp",
  componentId: "sc-3un9he-0"
})(["clear:both;", " .show-help{animation-timing-function:", ";}.show-help-enter,.show-help-appear{opacity:0;}@keyframes showHelpIn{0%{transform:translateY(-5px);opacity:0;}100%{transform:translateY(0);opacity:1;}}@keyframes showHelpOut{to{transform:translateY(-5px);opacity:0;}}"], makeMotion("show-help", "showHelp", "0.3s"), p => p.theme.transitions.easeInOut);
const Wrapper = styled(Text).withConfig({
  displayName: "help__Wrapper",
  componentId: "sc-3un9he-1"
})(["display:block !important;min-height:30px;padding:4px 8px;border-radius:", "px;"], p => p.theme.radii.base);
const statusColors = {
  default: {
    bg: "primary.1",
    text: "primary.6"
  },
  error: {
    bg: "negative.1",
    text: "negative.6"
  },
  warning: {
    bg: "warning.1",
    text: "warning.6"
  }
};
export const Help = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    status = "default",
    afterClose,
    className,
    children,
    minHeight,
    ...rest
  } = _ref;
  const contentRef = useRef(children);
  const statusRef = useRef(status);
  const visible = !!children;
  if (visible) {
    contentRef.current = children;
    statusRef.current = status;
  }
  const colors = statusColors[statusRef.current];
  return /*#__PURE__*/_jsx(StyledHelp, {
    ref: ref,
    minHeight: minHeight,
    children: /*#__PURE__*/_jsx(Motion, {
      visible: visible,
      motionName: "show-help",
      onLeaveEnd: afterClose,
      children: _ref2 => {
        let {
          className: motionClassName
        } = _ref2;
        return /*#__PURE__*/_jsx(Wrapper, {
          bg: colors.bg,
          ...rest,
          color: colors.text,
          className: cx(className, motionClassName),
          children: contentRef.current
        });
      }
    })
  });
});
export default Help;